import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { navigate } from '@reach/router';
import { Button, Flex } from 'components';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import {
  ActiveGames_activeGames,
  GameDifficulty,
  PlayerRole,
} from '../../../../graphql/types';
import PlayerView from '../../components/PlayerView';

interface Props {
  game: ActiveGames_activeGames;
  isSelectedScene?: boolean;
}

const GameTableRow = ({ game, isSelectedScene }: Props) => {
  const goToGame = () => {
    navigate(`/game/${game.id}`, {
      state: { pathname: window.location.pathname },
    });
  };
  const [t] = useTranslation();

  return (
    <tr>
      <Cell>{format(new Date(game.createdAt), 'd.M.y - HH:mm')}</Cell>
      {!isSelectedScene && (
        <>
          <Cell>
            <span css={css('max-width: 235px;display: inline-block;')}>
              {game.scene.name}
            </span>
          </Cell>
          <Cell>
            {game.gameDifficulty === GameDifficulty.EASY
              ? t('lobby.game.difficulty.easy', 'Základní')
              : t('lobby.game.difficulty.medium', 'Pokročilá')}
          </Cell>
        </>
      )}
      <Cell>
        {game.myRole === PlayerRole.EMPLOYEE
          ? t('lobby.game.employee', 'Zaměstnanec')
          : t('lobby.game.hacker', 'Hacker')}
      </Cell>
      <Cell>
        <PlayerView
          player={
            game.myRole === PlayerRole.EMPLOYEE ? game.hacker : game.employee
          }
        />
      </Cell>
      <Cell
        css={css`
          padding-right: 0;
        `}
      >
        <Flex alignItems="center">
          {game.turn === game.myRole ? (
            <Button
              css={ButtonCss}
              narrow
              variant={isSelectedScene ? 'primary' : 'warning'}
              labelT={{
                key: 'lobby.playTurnButton',
                defaultValue: 'Odehrát tah',
              }}
              onClick={goToGame}
            />
          ) : (
            <Button
              narrow
              labelT={{
                key: 'lobby.backToGameButton',
                defaultValue: 'Zpět do hry',
              }}
              variant={isSelectedScene ? 'outline-primary' : 'transparent'}
              onClick={goToGame}
              css={{
                ...ButtonCss,
                borderWidth: isSelectedScene ? undefined : 1,
              }}
            />
          )}
        </Flex>
      </Cell>
    </tr>
  );
};

export default GameTableRow;

const ButtonCss = {
  paddingTop: '0.3em',
  paddingBottom: '0.3em',
};

const Cell = styled.td`
  padding-right: 1em;
  font-size: 14px;
  text-align: left;
`;
